export default __webpack_public_path__ + "static/media/background-people.118da78c.svg";